import {
  parseApiEnvelope,
  parseApiErrorBody,
  type ApiEnvelope,
  type ApiError,
} from '@zunelo/shared';

export async function parseEnvelope<T>(
  response: Response,
  parseData?: (u: unknown) => T | null,
  fallbackErrorCode = 'HTTP_ERROR',
): Promise<ApiEnvelope<T>> {
  let rawJson: unknown;
  try {
    rawJson = await response.json();
  } catch {
    const apiError: ApiError = {
      code: 'MALFORMED_API_RESPONSE',
      message: `La API no devolvió JSON (${response.status}).`,
      status: response.status,
    };
    throw apiError;
  }

  if (!response.ok) {
    const errorParsed = parseApiErrorBody(rawJson);
    if (errorParsed.ok) {
      throw errorParsed.value.error;
    }
    const apiError: ApiError = {
      code: fallbackErrorCode,
      message: `La API respondió con estado ${response.status}.`,
      status: response.status,
    };
    throw apiError;
  }

  const envelopeParsed = parseApiEnvelope<T>(rawJson, parseData);
  if (!envelopeParsed.ok) {
    const apiError: ApiError = {
      code: 'MALFORMED_API_RESPONSE',
      message: `La respuesta de la API no tiene el formato esperado: ${envelopeParsed.reason}`,
      status: response.status,
    };
    throw apiError;
  }

  return envelopeParsed.value;
}
